import { TypedDocumentNode, gql } from '@apollo/client';

import useMutation from '@sorare/core/src/hooks/graphql/useMutation';

import {
  CreateArenaRequestMutation,
  CreateArenaRequestMutationVariables,
} from './__generated__/useCreateArenaRequest.graphql';

const KICK_OFF_CREATE_ARENA_REQUEST_MUTATION = gql`
  mutation CreateArenaRequestMutation(
    $input: footballRivalsArenaRequestCreateInput!
  ) {
    footballRivalsArenaRequestCreate(input: $input) {
      currentManager {
        id
        remainingArenaRequests
      }
      errors {
        code
        message
      }
    }
  }
` as TypedDocumentNode<
  CreateArenaRequestMutation,
  CreateArenaRequestMutationVariables
>;

const useCreateArenaRequest = () => {
  const [createArenaRequest, { loading }] = useMutation(
    KICK_OFF_CREATE_ARENA_REQUEST_MUTATION,
    {
      showErrorsWithSnackNotification: true,
      refetchQueries: ['RivalsArenaUpcomingQuery'],
    }
  );
  return { createArenaRequest, loading };
};

export default useCreateArenaRequest;
